import Modernizr from 'modernizr';
import WebFont from "webfontloader";
import ImagesLoaded from "imagesloaded";
import smoothscroll from 'smoothscroll-polyfill';

import 'slick-carousel';
import 'slick-lightbox';
import './slick-lightbox-custom.js';

$(() => {
	// Check behavior//*
	console.log($.fn);//OK
	console.log(Modernizr);//OK
	console.log(ImagesLoaded);//OK
	console.log(WebFont.load);//OK
	console.log(process.env.NODE_ENV);

	const WebFontConfig = {
		google: {
			families: ['Noto Sans JP:400,700']
		},
		monotype: {
			projectId: '776aefa9-3583-4b7e-b486-7e07750c9539',
		},
		active: function() {
			sessionStorage.fonts = true;
		}
	};
	if (typeof WebFont === 'object') {
		WebFont.load(WebFontConfig);
	};

	const setFillHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	window.addEventListener('resize', setFillHeight);
	setFillHeight();
	

	$(".sp-menu-toggle").click(function(){
		$(this).toggleClass('active');
		$('.sp-nav ul').toggleClass('active');
	});

	$("#works-toggle").click(function(){
		$(this).toggleClass('active');
		$('.works-grid').toggleClass('listed');
	});
	$("#works-sort-panel-toggle").click(function(){
		$('#works-sort-inner').slideToggle(200);
		$(this).toggleClass('active');
	});


	var searchBox = '.search-box'; // 絞り込む項目を選択するエリア
	var listItem  = '.list-item';   // 絞り込み対象のアイテム
	var hideClass = 'is-hide';     // 絞り込み対象外の場合に付与されるclass名

	$(function() {
		// 絞り込み項目を変更した時
		$(document).on('change', searchBox + ' input', function() {
			search_filter();
		});
	});

	/**
	 * リストの絞り込みを行う
	 */
	function search_filter() {
		// 非表示状態を解除
		$(listItem).removeClass(hideClass);
		for (var i = 0; i < $(searchBox).length; i++) {
			var name = $(searchBox).eq(i).find('input').attr('name');
			// 選択されている項目を取得
			var searchData = get_selected_input_items(name);
			// 選択されている項目がない、またはALLを選択している場合は飛ばす
			if(searchData.length === 0 || searchData[0] === '') {
				continue;
			}
			// リスト内の各アイテムをチェック
			for (var j = 0; j < $(listItem).length; j++) {
				// アイテムに設定している項目を取得
				var itemData = get_setting_values_in_item($(listItem).eq(j), name);
				// 絞り込み対象かどうかを調べる
				var check = array_match_check(itemData, searchData);
				if(!check) {
					$(listItem).eq(j).addClass(hideClass);
				}
			}
		}
	}

	/**
	 * inputで選択されている値の一覧を取得する
	 * @param  {String} name 対象にするinputのname属性の値
	 * @return {Array}       選択されているinputのvalue属性の値
	 */
	function get_selected_input_items(name) {
		var searchData = [];
		$('[name=' + name + ']:checked').each(function() {
			searchData.push($(this).val());
		});
		return searchData;
	}

	/**
	 * リスト内のアイテムに設定している値の一覧を取得する
	 * @param  {Object} target 対象にするアイテムのjQueryオブジェクト
	 * @param  {String} data   対象にするアイテムのdata属性の名前
	 * @return {Array}         対象にするアイテムのdata属性の値
	 */
	function get_setting_values_in_item(target, data) {
		var itemData = target.data(data);
		if(!Array.isArray(itemData)) {
				itemData = [itemData];
		}
		return itemData;
	}

	/**
	 * 2つの配列内で一致する文字列があるかどうかを調べる
	 * @param  {Array} arr1 調べる配列1
	 * @param  {Array} arr2 調べる配列2
	 * @return {Boolean}    一致する値があるかどうか
	 */
	function array_match_check(arr1, arr2) {
		// 絞り込み対象かどうかを調べる
		var arrCheck = false;
		for (var i = 0; i < arr1.length; i++) {
			if(arr2.indexOf(arr1[i]) >= 0) {
				arrCheck = true;
				break;
			}
		}
		return arrCheck;
	}

	smoothscroll.polyfill();
	document.addEventListener("click", e => {
		const target = e.target;
		if (!target.classList.contains("js-smooth-scroll")) return;
		e.preventDefault();
		const targetId = target.hash;
		document.querySelector(targetId).scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	});

	$('.mv-slider').slick({
		infinite: true,
    slidesToShow: 1,
    centerMode: true,
    initialSlide: 1,
    arrows: true,
		focusOnSelect: true,
		autoplay: true
	})
	
	$('.team-thumb').on('click',function(){
		var content = $(this).find('.mordal-content-wrapper').html();
		$('.mordal-wrapper').addClass('active');
		$('.mordal-inner').append(content);
	});
	$('.mordal-wrapper').on('click',function(){
		$(this).removeClass('active');
		$(this).find('.mordal-content').remove();
	});
	
	$('.image-modal').slickLightbox({
		background: 'rgba(255,255,255,.9)',
		caption: 'caption',
		htmlContent: true,
		slick:{
			fade: true,
			infinite: true,
			adaptiveHeight: true,
			speed: 240,
			arrows: true,
			lazy: false
		},
		layouts: {
			closeButton: '<span class="close-button"></span>'
		}
	});
	$('.ad-modal').slickLightboxCustom({
		background: 'rgba(255,255,255,.9)',
		htmlContent: true,
		closeOnBackdropClick: false,
		itemSelector: 'li.modal-thumb',
		slick:{
			fade: true,
			infinite: true,
			adaptiveHeight: true,
			speed: 240,
			arrows: true,
			lazy: false
		},
		layouts: {
			closeButton: '<span class="close-button"></span>'
		}
	});
});


// WEBPACK FOOTER //
// ./build/assets/js/scripts.js